import type { Driver } from '#domain/model/Driver.ts';

export const DriverName = ({ driver }: { driver: Driver | undefined }) => {
    if (!driver) {
        return null;
    }

    const displayValue = driver.name?.trim();

    return <span className='white-space-nowrap'>{displayValue}</span>;
};
